import { darkColors, lightColors } from "../../theme/colors";
import { NavTheme } from "./types";

export const light: NavTheme = {
  background: lightColors.card,
  hover: "#EEEAF4",
};

export const dark: NavTheme = {
  background: darkColors.card,
  hover: "#473d5d",
};
